import PropTypes from 'prop-types';
import React, { useMemo, memo, useCallback } from 'react';
import { Nav, NavItem } from 'react-bootstrap/lib';
import { LinkContainer } from 'react-router-bootstrap/lib';

const GroupNav = memo(({ id, activeKey }) => {
  const menu = useMemo(() => {
    if (!id) return [];
    return [
      {
        name: 'Setup',
        url: `/group/${id}/setup/0`,
        key: 'setup',
      },
      {
        name: 'Flow',
        url: `/group/${id}/flow/0`,
        key: 'flow',
        hidden: true,
      },
      {
        name: 'Audit',
        url: `/group/${id}/audit/0`,
        key: 'audit',
      },
    ];
  }, [id]);

  const renderMenuItem = useCallback(({ url, name, key, hidden }) => {
    if (hidden) return null;
    return (
      <LinkContainer to={url} key={key} eventKey={key}>
        <NavItem key={key}>{name}</NavItem>
      </LinkContainer>
    );
  }, []);

  return (
    <Nav activeKey={activeKey} bsStyle="tabs">
      {menu.map(renderMenuItem)}
    </Nav>
  );
});

GroupNav.propTypes = {
  id: PropTypes.string,
  activeKey: PropTypes.string,
};

export default GroupNav;
